import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import '../scss/inflow-sounce-picture.scss';

import { round } from 'mathjs';
import { styled } from '@mui/system';
import { LinearProgress } from '@mui/material';
import Color from '@/tool/color';
import { InFlow, OutFlow } from '@/styled/icon';
import moBility from '../../../store/mobility';
import { isEmpty } from 'lodash';

interface IProps { }
interface IState { }

const TalentChart = (props: IProps, state: IState) => {
  const [active, setActive] = useState<number>(0);
  const { talendList, talentActive } = moBility;

  const sum = (arr: any) => {
    if (arr.length > 0) {
      return arr?.reduce((prev: any, curr: any, idx: any, arr: any) => {
        return prev + curr;
      });
    }
    return 0;
  };

  const leftHeight = (val: number) => {
    const list: any = [];
    if (!isEmpty(talendList)) {
      talendList[talentActive]?.details.forEach((item: { ratio: number; }) => {
        list.push(item.ratio);
      });
      return `${(val / sum(list)) * (list.length * 50)}px`;
    }
    return '0px';
  };

  const DProgress = styled(LinearProgress)({
    borderRadius: '4px',
    height: '8px',
    backgroundColor: Color.blackColor(0.04),
  });

  const getPictureHeight = useMemo(() => {
    const list: any = [];
    if (!isEmpty(talendList)) {
      talendList[talentActive]?.details.forEach((item: { ratio: number; }) => {
        list?.push(item.ratio);
      });

      let val: number = 0;
      for (let i = 0; i < active + 1; i += 1) {
        if (i === active) {
          val += (list[i] / 2);
        } else {
          val += list[i];
        }
      }
      return `${(val / sum(list)) * (list.length * 50) - active * 50 + 4}px`;
    }
    return '0px'
  }, [talendList, talentActive])

  return (
    <section className="inflow-sounce-picture">
      {talentActive === 'inflow' && (
        <section className="inflow-sounce-picture-left">
          {
            talendList[talentActive]?.details?.map((item: any, i: number) => (
              <p
                style={{
                  backgroundImage: active === i ?
                    'url(https://file.smartsalary.cn/web-img%402.0/market/image/talentactive.png)' :
                    'url(https://file.smartsalary.cn/web-img%402.0/market/image/talent.png)',
                  width: '100px',
                  height: leftHeight(item.ratio),
                  backgroundSize: '100% 100%',
                }}
                key={`${i.toString()}`}
                onMouseEnter={() => { setActive(i); }}
                onMouseLeave={() => { setActive(0); }}
                className="left-items" />
            ))
          }
          <img src="https://file.smartsalary.cn/web-img%402.0/market/image/blue.png" alt=""
            className="inflow-sounce-picture-left-picture"
            style={{ height: `${getPictureHeight}`, top: `${active * 50 - 4}px` }} />
        </section>
      )}
      {talentActive === 'outflow' && (
        <section className="inflow-sounce-picture-left">
          {
            talendList[talentActive]?.details?.map((item: any, i: number) => (
              <p
                style={{
                  backgroundImage: active === i ?
                    'url(https://file.smartsalary.cn/web-img%402.0/market/image/outalentactive.png)' :
                    'url(https://file.smartsalary.cn/web-img%402.0/market/image/outalent.png)',
                  width: '100px',
                  height: leftHeight(item.ratio),
                  backgroundSize: '100% 100%',
                }}
                key={`${i.toString()}`}
                onMouseEnter={() => { setActive(i); }}
                onMouseLeave={() => { setActive(0); }}
                className="left-items" />
            ))
          }
          <img src="https://file.smartsalary.cn/web-img%402.0/market/image/yellow.png" alt=""
            className="inflow-sounce-picture-left-picture"
            style={{ height: `${getPictureHeight}`, top: `${active * 50 - 4}px` }} />
        </section>
      )}
      <section className="inflow-sounce-picture-mid">
        {
          talendList[talentActive]?.details?.map((item: any, i: number) => (
            <section className={active === i ? 'mid-items1' : 'mid-items'} key={`${i.toString()}`}>
              <p
                key={`${i.toString()}o`}>
                {talentActive === 'outflow' && (
                  <b
                    style={{
                      background: active === i ? Color.secondary : 'none',
                      borderColor: active === i ? Color.secondary : Color.ccc,
                    }} />
                )}
                {talentActive === 'inflow' && (
                  <b
                    style={{
                      background: active === i ? Color.primary : 'none',
                      borderColor: active === i ? Color.primary : Color.ccc,
                    }} />
                )}
                <span className="mid-item-name">{item.industry_name}</span>
                <span>{`${round(item.ratio * 100, 1)}%`}</span>
              </p>
              <section style={{ paddingLeft: 30 }}>
                <DProgress variant="determinate"
                  value={round(item.ratio * 100, 1)}
                  className={talentActive === 'outflow' ? 'out' : 'in'} />
              </section>
            </section>
          ))
        }
        <p className="mid-item-left-connect"
          style={{
            top: `${active * 50 + 16}px`,
            background: talentActive === 'outflow' ?
              Color.secondaryColor(0.6) : Color.primaryColor(0.6),
          }} />
      </section>
      <section className="inflow-sounce-picture-right">
        <section className="right-detail">
          {
            talendList[talentActive]?.details[active]?.sub_industries?.map((item: any, i: number) => (
              <section className="right-items" key={`${i.toString()}`}>
                <section className="icon-left">
                  {talentActive === 'outflow' ?
                    <span><OutFlow /></span> : <span><InFlow /></span>}
                </section>
                <section className="right-content">
                  <p
                    key={`${i.toString()}l`}>
                    <span className="right-item-name">{item.industry_name}</span>
                    <span>{`${round(item.ratio * 100, 1)}%`}</span>
                  </p>
                  <DProgress variant="determinate"
                    value={round(item.ratio * 100, 1)}
                    className={talentActive === 'outflow' ? 'out' : 'in'} />
                </section>
              </section>
            ))
          }
        </section>
      </section>
    </section>
  );
};

export default observer(TalentChart);
